import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type WholesaleAppFragment = { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null };

export const WholesaleAppFragmentDoc = gql`
    fragment WholesaleAppFragment on WholesaleAppType {
  id
  pk
  created
  email
  storeName
  storeType
  storeYear
  websiteUrl
  instagramUrl
  facebookUrl
  brands
  storeDescription
  status
  initialAddress {
    firstName
    lastName
    country
    city
  }
}
    `;